export const CATEGORIES = [
  { text: 'Last 3 updates', value: '3', },
  { text: 'Last 5 updates', value: '5', },
  { text: 'Last 10 updates', value: '10', },
  { text: 'All', value: 'all' },
];
